import { MobileScrollActionTypes } from './actions';
import { createCommand } from './plugin-factory';
export var setKeyboardHeight = function (keyboardHeight) {
    return createCommand({
        type: MobileScrollActionTypes.SET_KEYBOARD_HEIGHT,
        keyboardHeight: keyboardHeight,
    });
};
export var setHeightDiff = function (heightDiff) {
    return createCommand({
        type: MobileScrollActionTypes.SET_HEIGHT_DIFF,
        heightDiff: heightDiff,
    });
};
export var setWindowHeight = function (windowHeight) {
    return createCommand({
        type: MobileScrollActionTypes.SET_WINDOW_HEIGHT,
        windowHeight: windowHeight,
    });
};
//# sourceMappingURL=commands.js.map